import React, { useEffect, useRef } from 'react';
import { Switch, Route, useRouteMatch, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import InsightsWidgetsPage from '../containers/InsightsWidgetsPage';
import InsightsTasksViewPage from '../containers/InsightsTasksViewPage';
import InsightsFilter from '../containers/sections/InsightsFilter';
import { selectInsightsFilter } from '../../store/selectors/insights.selectors';
import { LoadInsights } from '../actions/insights.action';

const InsightsPage = () => {
  const match = useRouteMatch();
  const location = useLocation();

  const dispatch = useDispatch();
  const filter = useSelector(selectInsightsFilter);
  useEffect(() => {
    if (filter) {
      dispatch(new LoadInsights(filter));
    }
  }, [filter]);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    bodyClass: "m-4"
  });

  return (
    <>
      <div className="mt-5" ref={componentRef}>
        <InsightsFilter onPrint={handlePrint} isTaskDetails={match.path !== location?.pathname}/>
        <Switch>
          <Route exact path={match.url}>
            <InsightsWidgetsPage />
          </Route>
          <Route exact path={`${match.url}/tasks/:filterName/:filterValue?`}>
            <InsightsTasksViewPage />
          </Route>
        </Switch>
      </div>
    </>
  );
};

export default InsightsPage;
